var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isHKlandUser || _vm.canTenantRead
    ? _c(
        "div",
        [
          _vm.showFitout
            ? _c(
                "HKLTabs",
                {
                  staticClass: "submissions-entry",
                  attrs: { activeKey: _vm.myActiveKey },
                  on: { change: _vm.tabPaneChange },
                },
                [
                  _c(
                    "a-tab-pane",
                    { key: "1" },
                    [
                      _c("template", { slot: "tab" }, [
                        _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("tenantProjects.FitoutComment")) +
                              "\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.showSubmissionPin
                          ? _c(
                              "div",
                              { staticClass: "pin__bubble-orange tab_pin" },
                              [
                                _c("i", {
                                  staticClass: "fa fa-thumb-tack",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showFitoutDoc
                          ? _c("div", { staticClass: "tab-new-doc" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("tenantProjects.docs")) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("Submissions"),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "a-tab-pane",
                    { key: "2", staticClass: "submission-tab" },
                    [
                      _c("template", { slot: "tab" }, [
                        _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("tenantProjects.postFitout.title")
                              ) +
                              "\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.showLetterPin
                          ? _c(
                              "div",
                              { staticClass: "pin__bubble-orange tab_pin" },
                              [
                                _c("i", {
                                  staticClass: "fa fa-thumb-tack",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("PostFitOutEntry"),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.enableGreenFitOutFeature
                    ? _c(
                        "a-tab-pane",
                        { key: "3" },
                        [
                          _c("template", { slot: "tab" }, [
                            _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "tenantProjects.greenFitOut.tabTitle"
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.showGreenFitoutPin
                              ? _c(
                                  "div",
                                  { staticClass: "pin__bubble-orange tab_pin" },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-thumb-tack",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showGreenFitoutDoc
                              ? _c("div", { staticClass: "tab-new-doc" }, [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.$t("tenantProjects.docs")) +
                                      "\n        "
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("GreenFitOutEntry"),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showReinstatement
            ? _c(
                "div",
                { staticClass: "submissions-entry" },
                [_c("Submissions")],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _c("p", [_vm._v("\n  " + _vm._s(_vm.$t("noTabPermission")) + "\n")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }